import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';

export const Form = styled.form`
  display: grid;
  gap: 20px;
  padding: 30px;
  border-radius: 21px;
  background-color: ${({ theme }) => theme.palette.primary.background};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 15px;
    border-radius: 14px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: contents;
  }
`;

export const Title = styled(Typography.Header)`
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.primary.labels};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;

export const Inputs = styled.div`
  display: grid;
  gap: 20px;
  width: min(100%, 400px);

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
    gap: 15px;
  }
`;

export const SubmitButton = styled(Button)`
  height: 40px;
  border-radius: 10px;
  padding: 0 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 44px;
    order: 2;
    width: 100%;
    margin-top: 15px;
  }

  @media (hover: hover) {
    &:hover {
      background-color: #c1d9ff;
    }
  }
`;
